var render = function render(){var _vm=this,_c=_vm._self._c;return _c('amplify-authenticator',[_c('amplify-sign-in',{attrs:{"slot":"sign-in","header-text":_vm.title ? _vm.title : 'Authentication',"hide-sign-up":"","username-alias":"email"},slot:"sign-in"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }